import { useMemo } from "react";
import { propertyTypes as staticPropertyTypes } from "../@types/sharedSchema";

type PropertyTypes = {
  propertyTypes: string[];
};

// Property types are a fixed taxonomy, served from the shared static enum.
//
// This used to be fetched per-mount from the server's listings facet
// (GET /api/v1/listings-search/facets/property-types). That design had no
// static fallback and swallowed every failure into an empty list, so any
// backend hiccup (or opening a dialog before auth was ready) rendered every
// property-type dropdown in the app empty — a customer filmed exactly that on
// 2026-08-20 when a wedged instance 504'd the facet call. Measured against the
// live corpus that day, the dynamic facet differed from the enum by only 3
// long-tail values covering 0.1% of listings (one of them a Yad2 typo variant),
// so the fetch bought nothing worth the fragility.
export function usePropertyTypes(): PropertyTypes {
  return useMemo(() => ({ propertyTypes: [...staticPropertyTypes] }), []);
}
